// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__kMXp6"};